// @flow
import {
    HIDE_AUTOSUGGEST,
    HIDE_BACK_ARROW,
    HIDE_DIALOG,
    HIDE_MODAL_BOKECC,
    HIDE_PANEL,
    HIDE_SEARCH_BAR,
    HIDE_TOAST,
    SET_TITLE_BAR,
    SHOW_AUTOSUGGEST,
    SHOW_BACK_ARROW,
    SHOW_DIALOG,
    SHOW_MODAL_BOKECC,
    SHOW_PANEL,
    SHOW_SEARCH_BAR,
    SHOW_TOAST
} from '../actions/ui';

import type { Action } from './types';

const initialState = {
    showSidePanel: false,
    visibleToast: false,
    toastTitle: "",
    toastMessage: "",
    visibleModalBokecc: false,
    modalTitle: "",
    modalBody: "",
    showAutoSuggestPanel: false,
    hideBackArrow: false,
    showSearchBar: true,
    titleBar: "",
    dialogVisible: false,
    dialogTitle: "",
    dialogBody: "",
    onAccept: {},
    onCancel: {},
    goBack: null
};

//Reducer that manages the sidePanel visibility
export default function ui( state = initialState, action: Action ) {
    switch ( action.type ) {

        case SHOW_DIALOG:
            return {
                ...state,
                dialogVisible: true,
                dialogTitle: action.payload.dialogTitle,
                dialogBody: action.payload.dialogBody,
                onAccept: action.payload.onAccept,
                onAcceptCallback: action.payload.onAccept && action.payload.onAccept.callback ? action.payload.onAccept.callback : {},
                onCancel: action.payload.onCancel || {},
                onCancelCallback: action.payload.onCancel && action.payload.onCancel.callback ? action.payload.onCancel.callback : {},
                callback: action.payload.callback,
            };
        case HIDE_DIALOG:
            return { ...state, dialogVisible: false };
        case SHOW_PANEL:
            return { ...state, showSidePanel: true };
        case HIDE_PANEL:
            return { ...state, showSidePanel: false };
        case SHOW_TOAST:
            return {
                ...state,
                visibleToast: true,
                toastTitle: action.options.toastTitle,
                toastMessage: action.options.toastMessage
            };
        case HIDE_TOAST:
            return { ...state, visibleToast: false, toastTitle: "", toastMessage: "" };
        case SHOW_MODAL_BOKECC:
            return {
                ...state,
                visibleModalBokecc: true,
                modalTitle: action.options.modalTitle,
                modalBody: action.options.modalBody
            };
        case HIDE_MODAL_BOKECC:
            return { ...state, visibleModalBokecc: false };
        case SHOW_AUTOSUGGEST:
            return { ...state, showAutoSuggestPanel: true };
        case HIDE_AUTOSUGGEST:
            return { ...state, showAutoSuggestPanel: false };
        case SHOW_SEARCH_BAR:
            return { ...state, visibleSearchBar: true };
        case HIDE_SEARCH_BAR:
            return { ...state, visibleSearchBar: false };
        case HIDE_BACK_ARROW:
            return { ...state, hideBackArrow: true };
        case SHOW_BACK_ARROW:
            return { ...state, hideBackArrow: false };
        case SET_TITLE_BAR:
            return { ...state, titleBar: action.titleBar };
        default:
            return state;
    }
}